require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./videos-coverr-video-2.json") })
        }
      }, "path---videos-coverr-video-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---videos-coverr-video-2!./.cache/json/videos-coverr-video-2.json
// module id = 950
// module chunks = 231608221292675